export default __webpack_public_path__ + "static/media/ISWA.917f9294.png";